const routes = [
  {
    path: "/new-campaign-preference",
    name: "new-campaign-preference",
    component: () => import(/* webpackChunkName: "NewCampaignPreference" */ "./components/NewCampaignPreference"),
    props: route => ({
      isAutoCampaign: route.query.isAutoCampaign === 'true'
    })
  }
];

export default routes;
